import { render, staticRenderFns } from "./SharedLinkMain.vue?vue&type=template&id=25c3ccfd&scoped=true&"
import script from "./SharedLinkMain.vue?vue&type=script&lang=js&"
export * from "./SharedLinkMain.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkMain.vue?vue&type=style&index=0&id=25c3ccfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3ccfd",
  null
  
)

export default component.exports